import { GetComisionAlcanceByTipos } from "../../../reducers/comisionMembresia";

export interface ConfiguracionAlcancesStore extends GetComisionAlcanceByTipos {}

export const configuracionAlcancesStore: (
  state
) => ConfiguracionAlcancesStore = state => {
  const comisionMembresia = state.comisionMembresia;

  return {
    comisionesAlcance: comisionMembresia.comisionesAlcance,
    gettingComisionesAlcance: comisionMembresia.gettingComisionesAlcance,
    gettingComisionesAlcanceError:
      comisionMembresia.gettingComisionesAlcanceError
  };
};
